/**
 * Bständig Horizontal Carousel
 *
 * Wires up every `[data-bst-carousel]` container:
 *   - prev/next arrows scroll the track by roughly one viewport width
 *   - arrows are hidden at the start/end of the scroll range
 *   - also re-initialises on Shopify section:load (theme editor)
 */
(function () {
  function initOne(root) {
    if (root.dataset.bstCarouselReady === 'true') return;
    root.dataset.bstCarouselReady = 'true';

    var track = root.querySelector('[data-bst-carousel-track]');
    var prev = root.querySelector('[data-bst-carousel-prev]');
    var next = root.querySelector('[data-bst-carousel-next]');
    if (!track) return;

    function step() {
      var first = track.querySelector('li, .bst-carousel__slide');
      var cardWidth = first ? first.getBoundingClientRect().width : track.clientWidth * 0.5;
      var gap = parseFloat(getComputedStyle(track).columnGap || '16') || 16;
      var visible = Math.max(1, Math.floor(track.clientWidth / (cardWidth + gap)));
      return (cardWidth + gap) * visible;
    }

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.classList.toggle('is-disabled', track.scrollLeft <= 1);
      if (next) next.classList.toggle('is-disabled', track.scrollLeft >= max);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function init() {
    document.querySelectorAll('[data-bst-carousel]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
